import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  padding: ${rem(10)} ${rem(18)};
  gap: ${rem(14)};
  cursor: pointer;
  ${({ theme }) => theme.media.fold`
    padding: ${rem(8)} ${rem(20)};
    gap: ${rem(12)};
  `}
`;

export const RightArea = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${rem(8)};
  padding-bottom: ${rem(16)};
  border-bottom: ${({ theme }) => `1px solid ${theme.color['gray-200']}`};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(6)};
  `}
`;

export const TopArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`;

export const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
  ${({ theme }) => theme.media.fold`
    gap: 0; 
  `}
`;

export const LabelArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  text-align: right;
`;

export const Label = styled.div`
  display: flex;
  align-items: baseline;
`;

export const DescriptionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
`;
